import React from 'react';
import {kdaColor, scoreColor} from "../../../../function";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: ${props => {
    let direction = 'row';
    if (props.reverse) direction = 'row-reverse';
    return direction;
  }};
`;

const KdaText = styled.span`
  font-size: 12px;
`;

const StatisKDA = styled.span`
  font-size: 12px;
  color: #313131;
  opacity: 0.6;
`;

const MarginbBox = styled.div`
  margin-right: ${props => {
    let right = 0;
    if (props.reverse) right = '6px';
    return right
  }};
  margin-left: ${props => {
    let left = '6px';
    if (props.reverse) left = 0;
    return left
  }};;
`;
const SeasonScore = ({kda, seasonAiScore, reverse}) => {


    return (
        <>
            <Wrapper
                reverse={reverse}
            >
                <MarginbBox reverse={reverse}>
                    <KdaText>{kdaColor(kda)}</KdaText>
                </MarginbBox>
                <MarginbBox reverse={reverse}>
                <StatisKDA>KDA</StatisKDA>
                </MarginbBox>
            </Wrapper>
        </>
    );
};

export default SeasonScore;